import {Chart} from 'chart.js';
import {Line} from 'vue-chartjs';


const MercuryVueChart = {
  install(Vue, options) {
    /*Vue.component('line-chart', {
      extends: Line,
      props: ['chartData', 'options'],
      mounted() {
        this['renderChart'](this.chartData, this.options)
      },
      watch: {
        "chartData": {
          handler: function () {
            console.log('cccc')
            this.$data['_chart'].update()
          },
          deep: true
        },
      }
    })

    Vue.component('word-cloud', {
      props: ['chartData', 'options', 'height'],
      template: `
        <div>
        <canvas ref="canvas" :height="height"></canvas>
        </div>
      `,
      mounted() {
        this['renderChart'](this.chartData, this.options)
      },
      watch: {
        "chartData": {
          handler: function () {
            this.$data['_chart'].update()
          },
          deep: true
        },
      },
      data() {
        return {
          _chart: undefined
        }
      },
      methods: {
        renderChart(chartData, options) {
          this._chart = new Chart(this.$refs['canvas'].getContext("2d"), {
            type: "wordCloud",
            data: chartData,
            options: options
          });
        }
      }
    })*/
  }
}

export default MercuryVueChart
